import {WhatsAppView} from "@src/pages/settings/integration-view/whatsapp";
import {createFileRoute, useMatches, useParams} from "@tanstack/react-router";
import {TIntegration, TProfile} from "@zeg/instant/types";
import {useSingleIntegration} from "@zeg/instant/w/useIntegrations";
import {intConfig} from "@zeg/shared/intConfig";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp"
)({component: RouteComponent});

function RouteComponent() {
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp",
  });
  const whatsappSlug = intConfig.whatsapp.slug;
  const activeProfile = accumulatedContext.auth.profiles.find(
    (profile: TProfile) => {
      const profileWorkspaceSlug = profile.$workspace?.slug;
      return profileWorkspaceSlug === workspaceSlug;
    }
  );
  const profileIdForHook = activeProfile?.id;
  const {data, isLoading, error} = useSingleIntegration(
    profileIdForHook as string,
    whatsappSlug
  );

  let integrations: TIntegration[] = [];
  if (profileIdForHook && data) {
    if ("profiles" in data && data.profiles?.[0]) {
      integrations = data.profiles[0].integrations || [];
    } else if ("integrations" in data) {
      integrations = data.integrations || [];
    }
  }

  return (
    <WhatsAppView
      integrations={integrations}
      isLoading={isLoading}
      error={error as Error}
      profile={activeProfile}
    />
  );
}
